import { jsx as _jsx } from "react/jsx-runtime";
import { toast, Slide } from "react-toastify";
import ErrorToastContent from "./ErrorToastContent";
export function makeToastKernelCallbacks(options) {
    const { disableProgressToasts = false, disableErrorToasts = false } = options ?? {};
    let prevToastId = null;
    const toastIds = [];
    const onProgress = (message) => {
        if (disableProgressToasts) {
            return;
        }
        const id = toast(message, {
            position: "bottom-right",
            transition: Slide,
            isLoading: true,
            hideProgressBar: true,
            closeButton: false,
        });
        toastIds.push(id);
        if (prevToastId) {
            toast.update(prevToastId, {
                isLoading: false,
                autoClose: 3000,
            });
        }
        prevToastId = id;
    };
    const onLoad = () => {
        toastIds.forEach((id) => toast.dismiss(id));
    };
    const onError = (error) => {
        if (disableErrorToasts) {
            return;
        }
        toast(_jsx(ErrorToastContent, { message: "Error during booting up", error: error }), {
            position: "bottom-right",
            type: "error",
            autoClose: false,
            closeOnClick: false,
        });
    };
    return {
        onProgress,
        onLoad,
        onError,
    };
}
//# sourceMappingURL=callbacks.js.map